import { DrawerFooter, Button } from "@chakra-ui/react";
import { useCallback } from "react";

interface Props {
  readOnlyUser: boolean;
  onClose: () => void;
  submitForm: (() => Promise<void>) & (() => Promise<any>);
  t: (key: string) => string;
  isCreate: boolean;
}

export const FormFooter = ({
  readOnlyUser,
  onClose,
  submitForm,
  t,
  isCreate,
}: Props) => {
  const handleCancel = useCallback(() => onClose(), [onClose]);

  const renderButtons = () => {
    if (readOnlyUser) {
      return (
        <>
          <Button
            variant="ghost"
            color="newBlue.500"
            onClick={handleCancel}
            mr={3}
          >
            {t("cancel")}
          </Button>
        </>
      );
    }

    return (
      <>
        <Button
          variant="ghost"
          color="newBlue.500"
          onClick={handleCancel}
          mr={3}
        >
          {t("cancel")}
        </Button>
        <Button
          layerStyle="ocean"
          _hover={{ layerStyle: "ocean" }}
          onClick={() => {
            submitForm();
          }}
        >
          {isCreate ? t("add") : t("save")}
        </Button>
      </>
    );
  };

  return <DrawerFooter>{renderButtons()}</DrawerFooter>;
};
